<template>
  <div v-if="branding" class="branding-header" :style="bandStyle">
    <img class="branding-header__image" :src="branding.headerImageUrl" :alt="alt">
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { BRANDING } from '@/utils/constants'

// A collection owner's custom header banner. Renders nothing unless a header
// image exists. The centered image keeps its 6:1 ratio and never exceeds
// HEADER_MAX_HEIGHT_PX; the optional background color + repeating background
// image fill the width the image does not cover on wide screens.
const props = defineProps({
  // { headerImageUrl, backgroundImageUrl, backgroundColor } or null. Use
  // resolveBranding() from @/utils/branding to build it.
  branding: {
    type: Object,
    default: null,
  },
  alt: {
    type: String,
    default: '',
  },
})

const bandStyle = computed(() => {
  const b = props.branding
  if (!b) return {}

  return {
    backgroundColor: b.backgroundColor || 'transparent',
    backgroundImage: b.backgroundImageUrl ? `url("${b.backgroundImageUrl}")` : 'none',
    '--branding-max-height': `${BRANDING.HEADER_MAX_HEIGHT_PX}px`,
  }
})
</script>

<style lang="scss" scoped>
.branding-header {
  display: flex;
  align-items: center;
  justify-content: center;
  // Must stay `auto`. A block-level flex box already fills its parent, and an
  // explicit `100%` over-constrains the box: the browser then discards the
  // negative `margin-right` a host uses to bleed the band past the page gutter
  // and resolves it positive instead, leaving the band short on the right.
  width: auto;
  overflow: hidden;
  background-repeat: repeat;
  background-position: center;
}

.branding-header__image {
  display: block;
  height: auto;
  max-width: 100%;
  max-height: var(--branding-max-height, 220px);
  object-fit: contain;
}
</style>
